import createAPI from "@/common/createApi.js"
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  // 查询认证源列表
  getProviderList: (realmName, config) =>
    createAPI(`/idaas/idP/admin/realms/${realmName}/identity-provider`, "get", config),
  // 获取可配置认证源列表
  getAbleProviderList: (realmName, config) =>
    createAPI(`/idaas/idP/admin/realms/${realmName}/identity-provider/usable`, "get", config),
  // 添加认证源获取认证源基本信息
  getProviderBase: (realmName, providerId, config) =>
		createAPI(`/idaas/idP/admin/realms/${realmName}/identity-provider/${providerId}`, "get", config),
  // 删除认证源
  deleteProvider: (realmName, providerId, config) =>
    createAPI(`/idaas/idP/admin/realms/${realmName}/identity-provider/${providerId}`, "delete", config),
  // 新建认证源
  addProvider: (realmName, config) =>
    createAPI(`/idaas/idP/admin/realms/${realmName}/identity-provider/instances`, "post", config),
  // 编辑认证源
  editProvider: (realmName, config, providerId) =>
    createAPI(`/idaas/idP/admin/realms/${realmName}/identity-provider/${providerId}`, "put", config),
  // cas添加认证源
  addCasProvider:  (realmName, config, providerId) =>
    createAPI(`/idaas/idP/admin/realms/${realmName}/identity-provider/instances/${providerId}`, "post", config),
  // 编辑cas认证源
  editCasProvider:  (realmName, config, providerId) =>
    createAPI(`/idaas/idP/admin/realms/${realmName}/identity-provider/third/${providerId}`, "put", config),
}
